import { useParams } from "react-router-dom"
import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"
import type { NewsletterDetail } from "@/types/api"
import { PaperCardItem } from "@/components/papers/PaperCard"
import { formatDate } from "@/lib/utils"

export default function NewsletterDetailPage() {
  const { id } = useParams()
  const path = id === "today" ? "/newsletters/today" : `/newsletters/${id}`
  const { data, isLoading, error } = useQuery({
    queryKey: ["newsletter", id],
    queryFn: () => api.get<NewsletterDetail>(path),
    enabled: !!id,
  })

  if (isLoading) return <div className="text-sm text-muted-foreground">불러오는 중...</div>
  if (error) return <div className="text-sm text-destructive">{(error as Error).message}</div>
  if (!data) return null

  return (
    <article className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">{data.title}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {formatDate(data.issue_date)} · {data.frequency} · {data.status}
        </p>
        {data.intro_ko && <p className="mt-4 text-base leading-7">{data.intro_ko}</p>}
      </header>
      {data.sections.map((sec) => (
        <section key={sec.key} className="space-y-3">
          <h2 className="border-b border-border pb-1 text-lg font-semibold">{sec.label}</h2>
          {sec.items.map((item) => <PaperCardItem key={item.paper.id} paper={item.paper} />)}
        </section>
      ))}
    </article>
  )
}
